import * as React from 'react';
import { IControlSchema } from '../../Controls';
import { Component, I18NString } from '../../Utils';
import Field from '../Field';
import { Button } from 'react-bootstrap';
import { isUndefined } from 'lodash';
import { IDispatcher } from '../extensions/Dispatcher';

interface LabelExtra {
  design?: Array<string>;
  showHelp?: any;
}

interface LabelSchema extends IControlSchema {
  extra?: LabelExtra;
  description?: I18NString;
}

interface LabelProps {
  schema: LabelSchema;
  dispatcher: IDispatcher;
}

interface LabelState {
  openInfo: boolean;
}

class Label extends Component<LabelProps, LabelState> {
  constructor(props) {
    super(props);
    this.state = {
      openInfo: false,
    };
    this.helpClick = this.helpClick.bind(this);
    this.fillTitleUrl = this.fillTitleUrl.bind(this);
  }
  componentDidMount(): void {
    if (
      typeof this.props.schema.extra !== 'undefined' &&
      this.props.schema.extra.showHelp
    ) {
      this.setState({ openInfo: true });
    }
  }

  fillTitleUrl(title_raw?: string) {
    const file_url_pattern = '{field_file_url}';
    if (
      !isUndefined(title_raw) &&
      title_raw != null &&
      title_raw.indexOf(file_url_pattern) !== -1
    ) {
      if (this.props.dispatcher) {
        let file_url = this.props.dispatcher.getFileUrl(
          this.props.schema.id,
          'label_file',
        );
        return title_raw.replace(file_url_pattern, file_url);
      }
    }
    return title_raw;
  }

  render() {
    const { extra } = this.props.schema;
    let helpBtn = null;
    if (!isUndefined(this.props.schema.description)) {
      helpBtn = (
        <Button
          onClick={this.helpClick}
          bsStyle="primary"
          title="Справка"
          className="btn btn-add btn-default btn-circle"
        >
          <span className="glyphicon glyphicon-question-sign"></span>
        </Button>
      );
    }

    let fixed_title: I18NString = {
      ru: this.fillTitleUrl(this.props.schema.title.ru),
      en: this.fillTitleUrl(this.props.schema.title.en),
    };

    if (this.props.schema.disabled) {
      return null;
    }

    return (
      <Field
        id={this.props.schema.id}
        required={this.props.schema.required}
        contentNumb={this.props.schema.contentNumb}
        title={fixed_title}
        disabled={this.props.schema.disabled}
        className={'label-field'}
        helpBtn={!isUndefined(this.props.schema.description) ? helpBtn : null}
        fullwidth={
          extra && extra.design && extra.design.indexOf('fullwidth') > -1
        }
        bordered={
          extra && extra.design && extra.design.indexOf('bordered') > -1
        }
      >
        <span>{helpBtn}</span>
        {!isUndefined(this.props.schema.description) && this.state.openInfo && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.description),
            }}
          ></div>
        )}
      </Field>
    );
  }
  helpClick() {
    this.setState({ openInfo: !this.state.openInfo });
  }
}

export function createLabel(
  schema: IControlSchema,
  dispatcher: IDispatcher = null,
) {
  return <Label schema={schema} dispatcher={dispatcher}></Label>;
}
